import { render, staticRenderFns } from "./folder_loader.vue?vue&type=template&id=5821327b"
import script from "./folder_loader.vue?vue&type=script&lang=js"
export * from "./folder_loader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports